import React from 'react';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';

export default ({ data, loading, comment }) => {
  return <InfoCardWidget primaryColor="#1b7ecf" secondaryColor="#595959"
                         icon="icon-people" title="Members Total"
                         data={data} loading={loading} comment={comment} />;
};



// WEBPACK FOOTER //
// ./src/components/pages/statistics/common/widgets/members.js